import React, { forwardRef } from "react";
import useTextResponseDateTime from "./useTextResponseDateTimeHook";
import { KeyboardTimePicker } from "@material-ui/pickers";

function TextResponseTime(props, ref) {
  const {
    value,
    flagMissing,
    error,
    userSkipped,
    handleOnChange,
    format,
    views
  } = useTextResponseDateTime(props);

  return (
    <KeyboardTimePicker
      inputRef={ref}
      value={userSkipped ? null : value}
      error={flagMissing || error}
      helperText={error && "Please enter a valid date"}
      onChange={handleOnChange}
      autoOk={true}
      format={format}
      views={views}
      ampm={true}
      margin={"normal"}
      style={{ width: "150px" }}
    />
  );
}

export default forwardRef(TextResponseTime);
